// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5724":"d876b722","8583":"e12c361b"}[chunkId] + ".chunk.css";
};